<template>
  <div class="desktop-wrapper">
    <desktop-header
      @locale="setLocale"
      :calname="calInfo.name"
      :schoolname="schoolName">
    </desktop-header>
    <div class="wrapper">
      <!-- Week Selector -->
      <week-selector
        :startDate="calInfo.start_date"
        :endDate="calInfo.end_date"
        :date="date"
        @changed="setDate">
      </week-selector>
      <!-- Fullcalendar -->
      <div class="box cal-container">
        <full-calendar-header
          :locale="locale"
          :date="date"
          :calview="calView"
          :isNotThisWeek="isNotThisWeek"
          @today="setToday"
          @prevWeek="prevWeek"
          @nextWeek="nextWeek">
        </full-calendar-header>
        <full-calendar
          :calendarId="calId"
          :locale="locale"
          :caldate="date"
          :events="allEvents"
          :viewState="calInfo.view_state"
          :i18n="i18n"
          @eventclick="showEvent"
          @view="setView">
        </full-calendar>
      </div>
      <!-- Weekplan -->
      <weekplan
        :locale="locale"
        :calId="calId"
        :date="date"
        :events="allEvents"
        :calview="calView.type">
      </weekplan>
    </div>
  </div>
</template>

<script>
  import desktopHeader from './Header.vue'
  import fullCalendar from '../../calendar/FullCal.vue'
  import fullCalendarHeader from '../../calendar/FullCalHeader.vue'
  import weekSelector from '../../datepicker/WeekSelecter.vue'
  import weekplan from './weekplan/WeekPlan.vue'
  import moment from 'moment'
  import docendo from '../../../docendo'
  import config from '../../../config'

  export default {
    components: {
      desktopHeader,
      weekSelector,
      fullCalendar,
      fullCalendarHeader,
      weekplan
    },
    props: {
      calId: {},
      schoolName: {},
      i18n: {}
    },
    data () {
      return {
        allEvents: [],
        date: config.now,
        today: config.now,
        locale: window.USER.locale,
        calInfo: '',
        calView: '',
        intervalId: null
      }
    },
    computed: {
      weekStartDate () {
        return moment(this.date).isoWeekday(1).format('YYYY-MM-DD')
      },
      weekEndDate () {
        return moment(this.date).isoWeekday(7).format('YYYY-MM-DD')
      },
      isNotToday () {
        return moment(this.date).format('YYYY-MM-DD') !== moment(this.today).format('YYYY-MM-DD')
      },
      isNotThisWeek () {
        return moment(this.date).isoWeek() !== moment(this.today).isoWeek()
      }
    },
    methods: {
      getSchoolInfo () {
        docendo.calendar(this.calId, (data) => {
          this.calInfo = data
        })
      },
      getLessons () {
        let start = this.weekStartDate
        let end = this.weekEndDate
        docendo.calendarPublicEvents(this.calId, start, end, true, null, true, (data) => {
          this.allEvents = data
        })
      },
      setDate (date) {
        this.date = date
        this.getLessons()
      },
      nextWeek () {
        let date = moment(this.date).add(7, 'days')
        this.setDate(date)
      },
      prevWeek () {
        let date = moment(this.date).subtract(7, 'days')
        this.setDate(date)
      },
      setToday () {
        this.setDate(this.today)
      },
      setView (view) {
        this.calView = view
      },
      showEvent (event) {
        this.$emit('eventClick', event)
      },
      setLocale (val) {
        this.locale = val
        this.$emit('setLocale', val)
      }
    },
    beforeMount () {
      if (window.location.href && window.location.href.indexOf('?update') > -1) {
        // Schedule it to be called every 5 minutes
        this.intervalId = setInterval(this.getLessons, 300000) // 300000 ms = 5 minutes
      }
    },
    mounted () {
      this.getSchoolInfo()
      this.getLessons()
      // Set date to calendar_current_date if user not student
      if (this.$helpers.getCookie('calendar_current_date_public') && this.$helpers.getCookie('calendar_current_date')) {
        this.setDate(this.$helpers.getCookie('calendar_current_date'))
      }
    },
    beforeDestroy () {
      // Clear the interval when the component is unmounted
      if (this.intervalId) {
        clearInterval(this.intervalId)
      }
    }
  }
</script>

<style scoped>
  .desktop-wrapper {
    min-width: 600px;
  }

  .wrapper {
    max-width: 1440px;
    margin: 0 auto;
  }

  .cal-container {
    display: flex;
    flex-direction: column;
  }

  @media print {
    .wrapper {
      max-width: 100vw;
    }

    .box {
      padding: 0;
      border-radius: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// DesktopView.vue?66c82eef